import React, { useState, useEffect } from 'react';

type Props = {
  src?: string | null;
  fallbackImage: string;
  alt: string;
  className?: string;
  fallbackClassName?: string;
  [key: string]: any;
};

const ImageWithFallback = (props: Props) => {
  const { fallbackImage, src, alt, className, fallbackClassName, ...rest } =
    props;

  const [useFallback, setUseFallback] = useState(!!src);

  useEffect(() => {
    setUseFallback(false);
  }, [src]);

  return (
    <img
      alt={alt}
      src={useFallback ? fallbackImage : src || fallbackImage}
      onError={() => setUseFallback(true)}
      className={useFallback ? fallbackClassName : className}
      {...rest}
    />
  );
};

export { ImageWithFallback };
